import React, { Component } from 'react';
import { connect } from 'react-redux';
import { setSearchFilters } from '../../../../redux/actions';
import * as routes from '../../../../constants/routes';
import { combineClassNames, createFiltersUrl } from '../../../../app/functions';
import filterIcon from '../../../../assets/icons/filter-icon.svg';
import ButtonOutlined from '../../../../components/common/buttons/button_outlined';
import SliderArrow from '../../../../components/common/shared/slider_arrow';
import CategorySlider from '../../../../components/common/sliders/category_slider';
import TagsSlider from '../../../../components/common/sliders/tags_slider';
import './index.scss';

class Filters extends Component {
    constructor(props) {
        super(props);

        const { tagsDefaultVisibility } = this.props;
        
        this.state = {
            tagsVisible: tagsDefaultVisibility,
        };

        this.handleCategorySelect = this.handleCategorySelect.bind(this);
        this.handleCategoryRemove = this.handleCategoryRemove.bind(this);
        this.handleTagSelect = this.handleTagSelect.bind(this);
        this.handleTagRemove = this.handleTagRemove.bind(this);
        this.handleTagsButtonClick = this.handleTagsButtonClick.bind(this);
        this.handleTagsResetClick = this.handleTagsResetClick.bind(this);
        this.appendUrlParams = this.appendUrlParams.bind(this);
    }

    shouldComponentUpdate(nextProps, nextState) {
        const {
            availableCategories,
            availableTags,
            deviceState,
            searchFilters,
        } = this.props;

        return (
            availableCategories !== nextProps.availableCategories
            || availableTags !== nextProps.availableTags
            || deviceState !== nextProps.deviceState
            || searchFilters !== nextProps.searchFilters
            || this.state !== nextState
        );
    }

    handleCategorySelect(categoryId) {
        const { searchFilters } = this.props;

        const newFilters = {
            ...searchFilters,
            category: {
                ...searchFilters.category,
                id: categoryId,
            },
            benefitType: {
                ...searchFilters.benefitType,
                id: -1,
            },
        };

        this.appendUrlParams(newFilters);
        this.props.setSearchFilters(newFilters);
    }

    handleCategoryRemove() {
        this.handleCategorySelect(-1);
    }

    handleTagSelect(tagId) {
        const { searchFilters } = this.props;

        const newFilters = {
            ...searchFilters,
            benefitType: {
                ...searchFilters.benefitType,
                id: searchFilters.benefitType.id === -1 ? [tagId] : [...searchFilters.benefitType.id, tagId],
            },
        };

        this.appendUrlParams(newFilters);
        this.props.setSearchFilters(newFilters);
    }

    handleTagRemove(tagId) {
        const { searchFilters } = this.props;

        const newFilters = {
            ...searchFilters,
            benefitType: {
                ...searchFilters.benefitType,
                id: searchFilters.benefitType.id.filter(
                    (savedTagId) => savedTagId !== tagId
                ),
            },
        };

        if (newFilters.benefitType.id.length === 0) {
            newFilters.benefitType.id = -1;
        }

        this.appendUrlParams(newFilters);
        this.props.setSearchFilters(newFilters);
    }

    handleTagsButtonClick() {
        const newState = {
            ...this.state,
            tagsVisible: !this.state.tagsVisible,
        };

        this.setState(newState);
    }

    handleTagsResetClick() {
        const { searchFilters } = this.props;

        const newFilters = {
            ...searchFilters,
            benefitType: {
                ...searchFilters.benefitType,
                id: -1,
            },
        };

        this.appendUrlParams(newFilters);
        this.props.setSearchFilters(newFilters);
    }

    appendUrlParams(filters) {
        const urlParams = {};

        for (const filterKey in filters) {
            if (filters[filterKey].id !== -1) {
                urlParams[filterKey] = filters[filterKey].id;
            }
        }

        const stringUrlParams = createFiltersUrl(urlParams);

        const newUrl = routes.benefits + (stringUrlParams ? '?' + stringUrlParams : '');

        window.history.replaceState({}, null, newUrl);
    }

    render() {
        const {
            availableCategories,
            availableTags,
            translations,
            deviceState,
            searchFilters,
        } = this.props;
        const { tagsVisible } = this.state;

        const isMobileOrTablet = (deviceState === 'mobile' || deviceState === 'tablet');

        const selectedCategory = searchFilters.category.id;
        const selectedTags = Array.isArray(searchFilters.benefitType.id) ? searchFilters.benefitType.id : [];

        const hasSelectedTags = (searchFilters.benefitType.id !== -1);

        const TagsToggleButton = () => (
            <ButtonOutlined
                type="button"
                className="filters-tags-button"
                onClick={this.handleTagsButtonClick}
            >
                <img
                    src={filterIcon}
                    alt="Filter Icon"
                    className="filters-tags-button-icon"
                />

                {translations['all_benefits_tags_button']}
            </ButtonOutlined>
        );

        const TagsCloseButton = () => (
            <button
                type="button"
                className="filters-link-button"
                onClick={this.handleTagsButtonClick}
            >
                {translations['all_benefits_close_button']}
            </button>
        );

        const TagsResetButton = () => (
            <button
                type="button"
                className="filters-link-button"
                onClick={this.handleTagsResetClick}
            >
                {translations['all_benefits_reset_button']}
            </button>
        );

        return (
            <section className="benefits-filters-container">
                <div className="filters-upper-row">
                    <div className="filters-categories">
                        <CategorySlider
                            selectedCategory={selectedCategory}
                            availableCategories={availableCategories}
                            onCategorySelect={this.handleCategorySelect}
                            onCategoryRemove={this.handleCategoryRemove}
                            customSliderSettings={{
                                shared: {
                                    nextArrow: isMobileOrTablet
                                        ? (<SliderArrow />)
                                        : (<SliderArrow variant="circular" />),
                                    prevArrow: isMobileOrTablet
                                        ? (<SliderArrow />)
                                        : (<SliderArrow variant="circular" />),
                                },
                                mobile: {
                                    slidesToShow: 4,
                                    slidesToScroll: 4,
                                },
                                tablet: {
                                    slidesToShow: 7,
                                    slidesToScroll: 7,
                                },
                                desktop: {
                                    slidesToShow: 8,
                                    slidesToScroll: 8,
                                },
                                desktopLarge: {
                                    slidesToShow: 9,
                                    slidesToScroll: 9,
                                },
                            }}
                        />
                    </div>

                    <div className="filters-tags-button-container">
                        <div>
                            {isMobileOrTablet && tagsVisible && (
                                <TagsCloseButton />
                            )}
                        </div>

                        <TagsToggleButton />

                        <div>
                            {isMobileOrTablet && hasSelectedTags && (
                                <TagsResetButton />
                            )}
                        </div>
                    </div>
                </div>

                <div
                    className={combineClassNames(
                        'filters-middle-row',
                        this.state.tagsVisible && 'filters-middle-row_visible',
                    )}
                >
                    <div className="filters-tags">
                        <TagsSlider
                            selectedTags={selectedTags}
                            availableTags={availableTags}
                            onTagSelect={this.handleTagSelect}
                            onTagRemove={this.handleTagRemove}
                            customSliderSettings={{
                                mobile: {
                                    slidesToShow: 2,
                                    slidesToScroll: 2,
                                },
                                tablet: {
                                    slidesToShow: 3,
                                    slidesToScroll: 3,
                                },
                                desktop: {
                                    slidesToShow: 3,
                                    slidesToScroll: 3,
                                },
                                desktopLarge: {
                                    slidesToShow: 5,
                                    slidesToScroll: 5,
                                },
                            }}
                        />
                    </div>

                    {!isMobileOrTablet && (
                        <div className="filters-actions-line">
                            <TagsCloseButton />

                            {hasSelectedTags && (
                                <TagsResetButton />
                            )}
                        </div>
                    )}
                </div>
            </section>
        );
    }
}

const mapStateToProps = (store) => {
    return {
        translations: store.config.Translations,
        deviceState: store.state.deviceState,
        searchFilters: store.state.benefitSearchFilters,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setSearchFilters: (payload) => dispatch(setSearchFilters(payload)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps, null, { pure: false })(Filters);
